import ButterImage from '../../components/ButterImage'

export type SupportedOrganizationsProps = {
  readonly title: string
  readonly organizations: ReadonlyArray<{
    readonly image?: string
    readonly name: string
    readonly websiteUrl: string
  }>
}

/**
 * This component renders a people teaser block with person list.
 * @param title title of the block
 * @param organizations list of organizations
 */
export default function SupportedOrganizations({
  organizations,
  title,
}: SupportedOrganizationsProps) {
  return (
    <section style={{ padding: '0 15px' }}>
      <h3 style={{ textAlign: 'center', marginBottom: 35 }}>{title}</h3>

      <ul style={{ listStyle: 'none' }}>
        {organizations.map(({ image, name, websiteUrl }) => (
          <li key={name}>
            {!!image && <ButterImage src={image} alt={`${name} company logo`} />}

            <p style={{ textAlign: 'center' }}>
              <a href={websiteUrl} target='_blank' rel='noreferrer'>
                {name}
              </a>
            </p>
          </li>
        ))}
      </ul>
    </section>
  )
}
